export const FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_FAILURE = 'FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_FAILURE';

export const findProcessStatementCommentVisibilityFailure = error => ({
    type: FIND_PROCESS_STATEMENT_COMMENT_VISIBILITY_FAILURE,
    payload: error,
    error: true,
});
